import React from 'react'

import { Box, Tooltip, Typography, Skeleton } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

const multiNoWrap = lines => {
  return {
    lineClamp: lines,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical'
  }
}

export const useStyles = makeStyles(
  ({ palette, typography, spacing, breakpoints, props }) => ({
    skillBiteInfo: {
      flex: 1
    },
    skillBiteInfoBorder: {
      borderLeft: `5px solid ${palette.primary.main}`,
      paddingLeft: props => props.variant === 'main' ? 16 : 8
    },
    skillBiteName: {
      ...typography.heading.h4,
      ...multiNoWrap(2),
      marginBottom: 8
    },
    skillBiteDescription: props => props.variant === 'main'
      ? { ...typography.body.m, ...multiNoWrap(3) }
      : { ...typography.body.s, ...multiNoWrap(3) },
    skillBiteInfoLoadingContainer: {
      display: 'flex',
      flexDirection: 'row',
      flex: 1,
      alignItems: 'center'
    },
    skillBiteInfoLoading: {
      flex: 1,
      paddingLeft: props => props.variant === 'main' ? 16 : 8
    }
  })
)

export const SkillBiteInfoContainer = ({ isLoading, name, description, variant, imageUrl }) => {
  const classes = useStyles({ variant })

  function renderName () {
    if (variant !== 'secondary') {
      return (
        <Typography className={classes.skillBiteName}>
          {isLoading ? <Skeleton width={150} /> : name}
        </Typography>
      )
    }

    return (
      <Box display='flex' flexDirection='row' alignItems='center'>
        <Typography className={classes.skillBiteName} style={{ flex: 1, marginRight: 8 }}>
          {isLoading ? <Skeleton width={150} /> : name}
        </Typography>
        {isLoading ? <Skeleton width={120} height={66} style={{ borderRadius: 8 }} /> : <img src={imageUrl} alt={name} width={120} height={66} style={{ borderRadius: 8 }} data-test={`skill-bite-card-image-${name}`} />}
      </Box>
    )
  }

  if (isLoading) {
    return (
      <Box className={classes.skillBiteInfoLoadingContainer}>
        <Box style={{ height: '100%' }}>
          <Skeleton
            height='100%'
            width='6px'
          />
        </Box>
        <Box className={classes.skillBiteInfoLoading}>
          {renderName()}
          <Typography className={classes.skillBiteDescription}>
            <Box>
              <Skeleton width='100%' />
              <Skeleton width='85%' />
            </Box>
          </Typography>
        </Box>
      </Box>
    )
  }

  return (
    <Box className={classes.skillBiteInfo}>
      <Box className={classes.skillBiteInfoBorder}>
        <Box className={classes.skillBiteName} data-test={`skill-bite-card-name-${name}`}>
          {renderName()}
        </Box>
        <Tooltip title={description} aria-label={description} placement='top' data-test={`skill-bite-card-description-${name}`}>
          <Typography className={classes.skillBiteDescription}>
            {description}
          </Typography>
        </Tooltip>
      </Box>
    </Box>
  )
}
